import { ICellRendererComp, ICellRendererParams } from "ag-grid-community";
import { formatMessage } from "lib/globalize-util";
import { DATATEST } from "constants/integration";
class DefaultLabelCell implements ICellRendererComp {
    declare eGui: HTMLElement;

    private buildValueElement(params: ICellRendererParams) {
        this.eGui = document.createElement("div");
        this.eGui.className = "defaultHeader";

        const defaultColumn = document.createElement("div");
        defaultColumn.setAttribute("data-test", DATATEST.ASSORTMENTS.DEFAULT_ROW.DEFAULT_ROW_LABEL);
        defaultColumn.className = "defaultTitle";
        defaultColumn.innerHTML = formatMessage("Default");
        this.eGui.appendChild(defaultColumn);
    }

    refresh(): boolean {
        return true;
    }
    getGui(): HTMLElement {
        return this.eGui;
    }
    destroy(): void {
        // No-op
    }

    init(params: ICellRendererParams) {
        this.buildValueElement(params);
    }
}

export { DefaultLabelCell };
